import React from 'react'
import { IconTickGreen } from './icons'

import './CheckBox.scss'

export function CheckBox(props: {
  checked: boolean
  setChecked: (checked: boolean) => void
  children?: React.ReactNode
}) {
  return (
    <label className="CheckBox">
      <input type="checkbox" checked={props.checked} onChange={() => props.setChecked(!props.checked)}/>
      <div className="CheckBox-indicator">
        <img src={IconTickGreen} alt=""/>
      </div>
      <div className="label">
        {props.children}
      </div>
    </label>
  )
}
